const locale = {
  placeholder: 'Izaberite vreme',
};

export default locale;
